import React from "react";
import { Phone, Mail, MapPin } from "lucide-react"; // optional icons
import "./Support.css";

export default function Support() {
  return (
    <div className="support-container">
      
      {/* Header */}
      <section className="support-header">
        <h2>Customer Support</h2>
        <p>Your satisfaction is our priority. Contact us anytime.</p>
      </section>

      {/* Contact Cards */}
      <section className="support-contact">
        <div className="contact-card">
          <div className="icon-box">
            <Phone size={32} />
          </div>
          <h3>WhatsApp Support</h3>
          <p>+91 9047622009</p>
        </div>

        <div className="contact-card">
          <div className="icon-box">
            <Mail size={32} />
          </div>
          <h3>Email</h3>
          <p>support@cloudvu.in</p>
        </div>

        <div className="contact-card">
          <div className="icon-box">
            <MapPin size={32} />
          </div>
          <h3>Address</h3>
          <p>17/2, G K S Nagar, Pappanaickenpalayam,<br /> Coimbatore, Tamil Nadu 641037</p>
        </div>
      </section>

      {/* Footer */}
      <footer className="support-footer">
        <p>© {new Date().getFullYear()} Cloudvu Technologies. All Rights Reserved.</p>
        <p>support@cloudvu.in | +91 9047622009</p>
      </footer>
    </div>
  );
}
